<template>
  <button
    type="button"
    class="flex items-center justify-center sm:justify-start gap-2 w-9 sm:w-auto h-9 sm:px-2.5 rounded-md border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 dark:focus-visible:ring-accent-dark/40"
    :class="
      active
        ? 'border-brand-orange/40 dark:border-accent-dark/40 bg-brand-orange/10 dark:bg-accent-soft-dark hover:bg-brand-orange/15 dark:hover:bg-accent-soft-hover-dark'
        : 'border-container-border dark:border-container-border-dark bg-input-bg dark:bg-input-bg-dark hover:bg-secondary-bg dark:hover:bg-secondary-bg-dark'
    "
    :aria-pressed="active"
    :aria-label="t('components.viewAsStandardToggle.label')"
    :title="t('components.viewAsStandardToggle.label')"
    @click="emit('toggle', !active)"
  >
    <MdiAccountEye
      class="text-[18px] shrink-0"
      :class="
        active
          ? 'text-brand-orange dark:text-accent-dark'
          : 'text-muted-text dark:text-muted-text-dark'
      "
      aria-hidden="true"
    />

    <span
      class="hidden sm:block text-sm font-medium whitespace-nowrap"
      :class="
        active
          ? 'text-brand-orange dark:text-accent-dark'
          : 'text-heading dark:text-heading-dark'
      "
    >
      {{ t("components.viewAsStandardToggle.short") }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import MdiAccountEye from "~icons/mdi/account-eye";

const { t } = useI18n({ useScope: "global" });

defineProps<{
  active: boolean;
}>();

const emit = defineEmits<{
  toggle: [enabled: boolean];
}>();
</script>
